module.exports = __webpack_public_path__ + "images/backgrounds/fall/full.72c32b15d265b78e7058.jpg";